<template>
    <div class="custom-tooltips">
        <div class="tooltips d-grid-12" :class="{ scale_1: tooltipsShow }">
            <div class="grid-cspan-11">
                <slot name="tooltips"></slot>
            </div>
            <div class="grid-cspan-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M18 6L6 18"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M6 6L18 18"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
        </div>
        <div
            class="d-flex-between-center setting-nota content"
            style="align-items: baseline;"
            :class="{ drafted: isShowDraft }"
        >
            <slot name="content"></slot>
            <div style="margin-top: 6px;" @mouseenter="toogleTooltips" @mouseleave="toogleTooltips">
                <IconBased width="18" height="18">
                    <template v-slot:icons>
                        <QuestionMarkCircle clr-fill="#6F7287" />
                    </template>
                </IconBased>
            </div>
        </div>
        <div class="msg-container" v-if="isShowDraft">
            <div class="message-wrapper">
                <div class="draft-msg">
                    <div class="msg f-14 f-regular">
                        <slot name="draftmsg"></slot>
                    </div>
                    <label class="m-d-0 f-c-blue f-12 f-semi" @click="showDetail">
                        Lihat detail
                        <IconBased width="10" height="6">
                            <template v-slot:icons>
                                <NextDown />
                            </template>
                        </IconBased>
                    </label>
                </div>
            </div>
            <div class="duration" v-if="isDuration">
                <slot name="duration"></slot>
            </div>
        </div>
    </div>
</template>
<script>
import IconBased from "./iconPack/IconBased.vue";
import QuestionMarkCircle from "./iconPack/QuestionMarkCircle1818.vue";
import NextDown from "./iconPack/NextDown.vue";

export default {
    name: "ItemSettingWA",
    props: {
        jenisSetting: {
            type: String,
            default: "",
        },
        isShowDraft: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        IconBased,
        QuestionMarkCircle,
        NextDown,
    },
    data() {
        return {
            tooltipsShow: false,
        };
    },
    computed: {
        isDuration() {
            return !!this.$slots.duration;
        },
    },
    methods: {
        toogleTooltips() {
            this.tooltipsShow = !this.tooltipsShow;
        },
        showDetail() {
            this.$router.push({
                name: "wa_autosender.detail_perangkat.daftar_oulet.preview_msg",
                query: { jenisSetting: this.jenisSetting },
            });
        },
    },
};
</script>

<style scoped>
.custom-tooltips {
    position: relative;
}

.custom-tooltips .tooltips,
.custom-tooltips .arrow {
    --scale: 0;
    --tooltip-color: #333;
    --arrow-size: 10px;

    position: absolute;
    top: 1.25rem;
    left: 50%;
    transform: translateX(-50%) translateY(var(--translate-y, 0)) scale(var(--scale));
    transition: 150ms transform;
    transform-origin: bottom center;
}

.custom-tooltips .tooltips {
    --translate-y: calc(-100% - var(--arrow-size));
    color: white;
    border-radius: 0.6rem;
    text-align: center;
    padding: 0.6rem;
    width: max-content;
    max-width: 92vw;
    background: var(--tooltip-color);
}

.custom-tooltips .scale_1 {
    --scale: 1;
}

.setting-nota {
    background-color: #ffffff;
    box-shadow: 0px 4px 12px rgba(0, 34, 119, 0.06);
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 8px;
}

.drafted {
    margin-bottom: unset;
    border-bottom-right-radius: unset;
    border-bottom-left-radius: unset;
}

.message-wrapper {
    max-height: 151px;
    padding: 12px;
    padding-top: 0px;
}

.msg-container {
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    background-color: #ffffff;
    margin-bottom: 8px;
}

.duration {
    padding: 0px 12px 12px;
}

.draft-msg {
    max-height: 109px;
    padding-left: 10px;
    padding-right: 10px;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
}

.msg {
    max-height: 85px;
    display: block;
    display: -webkit-box;
    height: 65px;
    overflow: hidden;
    line-height: 1.5;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
</style>
